export default {
      id: "icon-creatives-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-creatives",
      toString: function () {
        return this.url;
      }
    }